import { validationSchema as copyProjectValidationSchema } from "@clovis/server/src/app/domain/project/copy-project/copy-project.validation";
import { z } from "zod";

export const validationSchema = copyProjectValidationSchema.extend({
  name: z.string().nonempty(),
  /* projectId is undefined on project creation */
  projectId: z.string().uuid().optional(),
});
